import {trackEvent} from "../tracking/gtm";

export default class ApiDecodeExampleHandler {
  constructor($form) {
    this.$form = $form;
    this.$result = $(".js-api-decode-example-result");

    this.$result.html(renderSpinner());

    trackEvent("vin_decode_api");
  }

  always() {
  }

  done({message}) {
    this.cleanup();
    this.$result.html(renderResponse(message));

    try {
      window.Prism.highlightAll();
    } catch (ex) {
    }
  }

  fail({responseJSON}) {
    this.cleanup();

    if (responseJSON.hasOwnProperty("message")) {
      this.$result.html(renderError(responseJSON.message));

      trackEvent(
        "form_error",
        {
          "form_error_text": responseJSON.message,
          "form_error_input": "apiDecodeSample-vin",
        }
      );
    }
  }

  cleanup() {
    this.$result.html("");
    this.$form.find("[name=recaptcha_token]").remove();
  }
}

function renderSpinner() {
  return `
    <div class="text-center">
      <div class="Spinner Spinner--30px m-2">
        <div class="Spinner-1"></div>
        <div class="Spinner-2"></div>
      </div>
    </div>
  `
}

function renderError(msg) {
  return `
    <p class="FormControl-errorMsg py-2">
      ${msg}
    </p>
  `;
}

function renderResponse(msg) {
  return `<pre class="mt-0"><code class="language-json">${msg}</code></pre>`;
}
